import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../utils/Routes';
import styles from '../styles/Hero.module.css';


const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className={styles.heroSection}>
      <div className={styles.backgroundCircle}></div>
      <Container>
        <Row>
          <Col lg={6} className={styles.homeHeroContent}>
            <h1 className={styles.heroTitle}>
              Driving Smarter Growth, Stronger Communities, and Lasting Progress
            </h1>
            <p className={styles.heroDescription}>
              At Symbioun, we drive success through a holistic approach to business and community development. We align our expertise with your unique challenges, from investing in groundbreaking ideas and nurturing local talent to delivering tailored solutions that spark social change and empower communities. Together, we drive smarter growth that strengthens the fabric of society and creates lasting progress for generations to come.
            </p>
            <button className={styles.heroButton} onClick={() => navigate(ROUTES.CONTACTUS_ROUTE)}>
              Get Started
            </button>
          </Col>
          <Col lg={6} className={styles.heroImages}>
            <div className={styles.heroImageLayout}>
              {/* Left Image */}
              <div className={styles.leftImageContainer}>
                <img src="/images/Home/Hero-2.jpg" alt="Business growth" className={styles.mainImage} />
              </div>
              
              {/* Partner Logos List */}
              <div className={styles.partnerLogosList}>
                <div className={styles.partnerLogoItem}>
                  <img src="/images/Home/Partner-1.jpg" alt="Partner 1" />
                </div>
                <div className={styles.partnerLogoItem}>
                  <img src="/images/Home/Partner-2.jpg" alt="Partner 2" />
                </div>
                <div className={styles.partnerLogoItem}>
                  <img src="/images/Home/Partner-3.jpg" alt="Partner 3" />
                </div>
                <div className={styles.partnerLogoItem}>
                  <img src="/images/Home/Partner-4.jpg" alt="Partner 4" />
                </div>
                <div className={styles.partnerLogoItem}>
                  <img src="/images/Home/Partner-5.jpg" alt="Partner 5" />
                </div>
              </div>
              
              {/* Right Image with Background */}
              <div className={styles.rightImageContainer}>
                <div className={styles.imageBackgroundOverlay}>
                  <div className={styles.statsCard}>
                    <div className={styles.statsIcon}>
                      <img src="/icons/Home/stats.svg" alt="Stats icon" />
                    </div>
                    <div className={styles.statsContent}>
                      <h3>252+</h3>
                      <p>Total Projects</p>
                    </div>
                  </div>
                </div>
                <img src="/images/Home/Hero-1.png" alt="Business growth" className={styles.mainImage} />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Hero;